<kendo-dialog-titlebar *ngIf="!!documentInfoCollection">
    <div fxLayout="row wrap" fxLayoutGap="5">
        <button type="button" kendoButton (click)="prevPhoto()" icon="rewind"
            [disabled]="currentCollectionIndex === 0"> </button>
        <span>{{currentCollectionIndex + 1}} / {{collectionSize}}</span>
        <button type="button" kendoButton (click)="nextPhoto()" icon="forward"
            [disabled]="currentCollectionIndex === collectionSize-1"> </button>
        <button type="button" kendoButton (click)="rotateLeft()" icon="rotate-left"> </button>
        <button type="button" kendoButton (click)="rotateRight()" icon="rotate-right"> </button>
        <button type="button" kendoButton (click)="toogleImageMode()">
            <span [ngClass]="zoomMode ? 'k-icon k-i-zoom-out' : 'k-icon k-i-zoom-in'">
            </span>
        </button>
        
        <app-export-document-select *ngIf="canExport" [documentId]="documentInfo.id"></app-export-document-select>
        <span class="small-info">{{documentInfo.name}}</span>
                
    </div>
</kendo-dialog-titlebar>

<app-show-document-content
  [documentInfo]="documentInfo"
  [dialog]="dialog"
  [documentContent]="documentContent"
  [fileExtension]="fileExtension"
  [fileName]="fileName"
  [zoomMode]="zoomMode"
>
</app-show-document-content>